export const COMPARISON_HOVERED_ROW_ATTRIBUTE = 'data-hovered-row';
